module.exports = __webpack_public_path__ + "img/map-1-f-food.36e3e4c5.png";